import { render } from "./CxWarning.vue?vue&type=template&id=0379aefb"
import script from "./CxWarning.vue?vue&type=script&lang=js"
export * from "./CxWarning.vue?vue&type=script&lang=js"

import "./CxWarning.vue?vue&type=style&index=0&id=0379aefb&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__